"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function default_1({ maxWidth768 }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: maxWidth768 ? 'column' : 'row', gap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.default // ? room card top
            , { animation: "wave", variant: "rectangular", sx: {
                    flexShrink: 0,
                    aspectRatio: '1 / 1',
                    width: '120px',
                    height: '120px',
                    borderRadius: '10px',
                } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '6px',
                    width: '100%',
                    padding: '0 4px',
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '4px',
                            '> *': { flexShrink: 0 },
                            marginBottom: '2px',
                        } }, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "circular", sx: { width: '18px', height: '18px' } }), (0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '35%', height: '13px', borderRadius: '2px' } })] })), (0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '85%', height: '14px', borderRadius: '3px', marginBottom: '26px' } }), (0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '40%', height: '14px', borderRadius: '3px', marginBottom: '2px' } })] }))] })));
}
exports.default = default_1;
